<template>
  <div style="width:100%">
    <div class="container" v-loading="loading">
      <!-- 顶部按钮 -->
      <div class="topBtnPart">
        <div class="topBtn" style="margin-right:10px;">return to main page <span style="text-decoration: underline;" @click="returnHome">https://wch-ic.com/</span></div>
        <a style="display:inline-block;" class="topBtn" :href="downloadHref"><i class="el-icon-download"></i> export</a>
        <!-- @click="downloadImage" -->
      </div>
      <!-- 表格区域 -->
      <div v-if="tableData&&tableData.length>0" >
          <div  v-for="(item,index) in tableData" :key="index" class="tableContainer">
            <div class="tableTitle">
              {{item.title}}
            </div>
            <el-table :data="item.value" :max-height='tableMaxHeight'  border :header-cell-style='getHeadClass' stripe>
              <el-table-column :fixed='i==0 ? true: null'  v-for="(t,i) in item.meta" :key="i" :min-width="t.field=='fz'?'160px':'auto'" :width="setColumnWidth(t,i,item)" 
               :label="t.title=='USB Configuration②'?'USB Configuration':t.title" :property="t.field" align='center' >
                  <template slot-scope="scope">
                      <span v-if="t.head==1">
                          <a v-if="scope.row.url" class="cellClass" style="color:#005eb1; font-size:12px; cursor:pointer; text-align:center; font-weight:600;text-decoration:none;" :href="scope.row.url" target="_blank" >{{scope.row[scope.column.property]=='CH347F③'?'CH347F':scope.row[scope.column.property]}}</a>
                          <span class="cellClass" v-else style="font-size:12px;color:#005eb1;text-align:center; font-weight:600;text-decoration:none;">
                              {{scope.row[scope.column.property]=='CH347F③'?'CH347F':scope.row[scope.column.property]}}
                          </span>
                      </span>
                      <span v-else class="cellClass">
                          <span v-if="scope.row[scope.column.property]" v-html="scope.row[scope.column.property]"></span>
                          <span v-else>-</span>
                      </span>
                  </template>
              </el-table-column>
            </el-table>
          </div>
      </div>
   
      <div style="font-weight: bolder;font-size: 13px;line-height:14px; margin-top: 30px;color: #666666; text-align:left;">
				<p class="bottomP">Note 1: WCH provides a variety of USB serial port drivers, support Windows/Linux/Android/Mac OS and other operating systems. Driver type description:</p>
				<p class="bottomP" style="text-indent: 2rem;">VCP：The manufacturer provides an emulated serial port driver, supports various operating systems, has multiple functions, high efficiency, and supports high baud rate communication, hardware flow control, GPIO and other functions. The driver only needs to be installed once or it can be installed automatically through the Internet.</p>
        <p class="bottomP" style="text-indent: 2rem;">HID: All operating systems have built-in this driver, and users do not need to install manually; the disadvantage is that the baud rate supports up to 115200bps, and not compatible with conventional serial port application software.</p>
        <p class="bottomP" style="text-indent: 2rem;">CDC：For operating system versions lower than Windows 10, users need to install manually. Due to the CDC protocol and features of class driver, the CDC serial port function is not as complete as VCP, and there are some differences in use. For details, see the following application description:</p>
        
        <p style="text-indent: 2rem;" ><a  style="color: #000!important;font-size:16px;" href="http://www.wch.cn/application/357.html">USB to serial port application</a></p>
		  </div>

    </div>

  </div>
</template>

<script>
import { getAction, postAction, postFormAction, downFile} from '@/request/http'//引入封装的get post方法
import axios from 'axios'
export default {
  name: "Home",
  components:{
  },
  data() {
    return {
        loading:false,
        tableData:[],
        tableMaxHeight:800,
        downloadHref:window._CONFIG['domianURL']+'/api/official/website/productTables/enUsbProductDownload',
        url:{
          usbUrl:'/api/official/website/productTables/getEnUsbProductTable',
        },
        loading_export:false,
    };
  },
  computed: {
  },
  watch:{
  },
  mounted() {
    this.setTableHeight()
    this.getTableData()
  },
  activated(){
  },
  methods:{
    //获取浏览器高度
    setTableHeight(){
      console.log('高度',  window.screen.availHeight)//window.screen.height
      let height = window.screen.availHeight
      if(height<=1000){
        this.tableMaxHeight=600
      }else{
        this.tableMaxHeight=800
      }
    },
    
    //获取表格
    getTableData(){
      let arr = []
      let single_arr = []
      let multiple_arr = []
      this.tableData = []
      getAction(this.url.usbUrl)
        .then(res => {
          this.loading = true;
          if(res.data.code===0 && res.data.data){
            arr = [res.data.data]

            arr[0].meta = JSON.parse(arr[0].meta)
            arr[0].value = JSON.parse(arr[0].value)
            arr[0].value.forEach((item)=>{
              if(item.xh == 'CH347F③'){
                item.xh = 'CH347F'
              }else if(item.xh == 'CH347T③'){
                item.xh = 'CH347T'
              }

              if(item.url.indexOf('wch-ic')==-1){
                item.url = 'https://www.wch-ic.com'+item.url
              }
            })
            

            single_arr = JSON.parse(JSON.stringify(arr)) 
            multiple_arr = JSON.parse(JSON.stringify(arr)) 
           
            this.$nextTick(()=>{
              single_arr[0].title = 'USB To Single UART' 
              single_arr[0].value = single_arr[0].value.filter((item,index)=>{
                return item.cksl=='1/2'||item.cksl=='1'
              })
              multiple_arr[0].title = 'USB To Multiple UARTs'
              multiple_arr[0].value = multiple_arr[0].value.filter((item,index)=>{
                return item.cksl=='1/2'||item.cksl>1
              })

              this.tableData = single_arr.concat(multiple_arr) 
              console.log('tableData', this.tableData)
            })
            
          }else{
            this.$message.error(res.data.message);
          }
          this.loading = false;
      });
    },

   
    //设置表格部分列宽度
    setColumnWidth(t,i,item){

     if(i==0){
      return '110px';
     } else if(t.field=='zdbtl'){
      return '160px'
     } else if(t.field=='Flow_CC'){
      return '250px'
     } else if(t.field=='qdlx'){
      return '130px'
     } else if(t.field=='yjlk'){
      return '160px'
     } else if(t.field=='zd485kz'){
      return '120px'
     } else if(t.field=='USBpzgn'){
      return '180px'
     } else if(t.field=='Dual_PS'){
      return '300px'
     } else if(t.field=='Modem'){
      return '280px'
     } else if(t.field=='gzwd'){
      return '160px'
     }

     else if(t.field=="fz"){
      return 'auto'
     }
     else{
      return t.width
     }
    },


    //自定义表头样式
    getHeadClass({rowIndex}){
      if(rowIndex==0){
        return 'background-color:#A5BE70;color:#1F7962;font-size:13px;text-algin:center;font-weight:700;word-wrap: break-word;word-break:normal; '
      }
      else{
        return "color:#666; font-size:12px;text-algin:center; background-color:#fff;break-word;word-break:normal; "
      }
    },

    // 返回主页面
    returnHome(){
      window.location.href='https://wch-ic.com/'
    },
  

  
     
     
      
  }
};
</script>
<style scoped >
.container {
  width: 88%;
  margin: 0 auto;
  margin-top: 20px;
  background: #fff;
  position: relative;
}
.topBtnPart{
  display: flex;
}
.topBtn{
  border: 1px solid #1890ff;
  padding: 5px 10px;
  color: #1890ff;
  font-size: 13px;
  cursor: pointer;
}
.tableTitle{
  color: #014784;
  font-size: 30px;
  text-align: left;
  font-weight: 600;
  margin-bottom: 10px;
}
.tableContainer{
  margin-top: 40px;
}

.tableContainer /deep/.el-table .cell{
  padding-left: 0px;
  padding-right: 0px;
  line-height: 16px;
}
.tableContainer /deep/.el-table--border .el-table__cell:first-child .cell{
  padding-left: 0px;
}
.tableContainer /deep/.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    padding: 5px 0px;
}
.tableContainer /deep/.el-table th.el-table__cell>.cell{
    letter-spacing: -1px;
}
.tableContainer ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
	background: #E3E3E2 ;
}
.tableContainer ::v-deep.el-table {
  font-size: 12px;
}
.cellClass{
  word-wrap: break-word;
  word-break:normal;
  font-weight: 600;
}

.tableContainer /deep/.el-table td,
.tableContainer /deep/.el-table th{
    border: 1px solid #8ca558;
}
.tableContainer /deep/.el-table{
    border: 1px solid #8ca558;
    border-right: 2px solid #8ca558;
    border-bottom: 2px solid #8ca558;
}
.tableContainer ::v-deep.el-table td.el-table__cell, ::v-deep.el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #8ca558;
}
.tableContainer /deep/.greenCell{
  background: #b7d972a3 !important;
}

.bottomTips{
    font-size: 16px;
    line-height: 10px;
    text-align: left;
    color: #333;
}
@media  (max-width:585px){
  .topBtnPart{
    display: flex;
    margin-bottom: -35px;
    justify-content:flex-end;
    /* position: absolute;
    right: 0px;
    top: 10px; */
  }
}
@media  (min-width:584px){
  .topBtnPart{
    display: flex;
    /* margin-bottom: -35px;
    justify-content:flex-end; */
    position: absolute;
    right: 0px;
    top: 10px;
  }
}

/* 2K屏 */
@media (min-width: 2000px) and (max-width:2700px){
  .container {
    width: 70%;
  }
}
/* 4K屏 */
@media (min-width: 2701px) and (max-width:3900px){
  .container {
    width: 48%;
  }
}
/* 大于4K屏 */
@media (min-width: 3901px) {
  .container {
    width: 1840px;
  }
}


</style>
